export default {
  //支持米家注释
  support_mi_A: "本产品支持米家的中国大陆服务器。",
  support_mi_B: "本产品支持米家的中国大陆、欧盟、英国服务器。",
  support_mi_C: "本产品支持米家的中国大陆、欧盟、英国、俄罗斯服务器。",
};
